import { MechanicHotspot } from "@/abilities/mechanic/features/hotspots/models/mechanic-hotspot.model";
import { get, set } from "@vueuse/core";
import { defineStore } from "pinia";
import { computed, ref, reactive } from "vue";

export const useMechanicStore = defineStore("mechanicStore", () => {
    //flag to determine if the mechanic overlay in 3d/2d/list is open or closed
    //needed to check if the overlay was closed in another tab
    //undefined means it was never opened, we enter mechanic for the first time
    const overlayVisible = ref<boolean | undefined>(undefined);

    const visibleViews = reactive<string[]>([]);
    const hotspotsLoading = ref<boolean>(false);
    const hotspots = ref<MechanicHotspot[]>([]);

    function addHotspots(newHotspots: MechanicHotspot[]): void {
        set(hotspots, [...get(hotspots), ...newHotspots]);
    }

    function setHotspots(newHotspots: MechanicHotspot[]): void {
        set(hotspots, newHotspots);
    }

    function clearHotspots(): void {
        set(hotspots, []);
    }

    function getHotspotById(id: string): MechanicHotspot | undefined {
        return get(hotspots).find((hotspot) => hotspot.id === id);
    }

    function getHotspotByReference2d(id: string): MechanicHotspot | undefined {
        return get(hotspots).find((hotspot) => hotspot.reference2d === id);
    }

    function getHotspotByReference3d(id: string): MechanicHotspot | undefined {
        return get(hotspots).find((hotspot) => hotspot.reference3d === id);
    }

    function setHotspotLoading(loading: boolean): void {
        hotspotsLoading.value = loading;
    }

    return {
        overlayVisible,
        visibleViews,
        hotspotsLoading: computed(() => hotspotsLoading.value),
        setHotspots,
        hotspots: computed(() => hotspots.value),
        getHotspotById,
        clearHotspots,
        getHotspotByReference2d,
        getHotspotByReference3d,
        addHotspots,
        setHotspotLoading,
    };
});
